import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})

/* Types */
export const SET_PATRONS_COUNCELORS = 'SET_PATRONS_COUNCELORS'

export const PERSIST_PATRONS_COUNCELORS = 'PERSIST_PATRONS_COUNCELORS'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case SET_PATRONS_COUNCELORS:
			return new Immutable.Map(action.dataObj)
		case PERSIST_PATRONS_COUNCELORS:
			return state.set('persisted', action.persisted)
		default:
			return state;
	}
};

/* Action Creators */

export const getPatrons = (form) => {


	return (dispatch) => {

		form = Utils.ec_(form)

		form = { reference: form }

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getPatronData',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid, "n": localStorage.n})
		}).request().then(response => {
			dispatch(isLoading(false));

			response.data = Utils.ds_(response.data.reference)

			response.data.patronosConsejeros.consejero.forEach((item, i) => {
				try {
					if (item.correoElectronico.includes("|")) {
						let arr = item.correoElectronico.split("|")
						item.correoElectronico = arr[0]
						item.telefono = arr[1]
					}
				} catch (e) {console.log(e,'<--- err');}
			});

			let dataObj = {...response.data.patronosConsejeros, persisted: false}

			dispatch({type: SET_PATRONS_COUNCELORS, dataObj })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const savePatron = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/savePatron',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then( () => {
			dispatch(isLoading(false));
			dispatch({ type: PERSIST_PATRONS_COUNCELORS, persisted: true })
			dispatch({ type: PERSIST_PATRONS_COUNCELORS, persisted: false })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const deletePatron = (idDonataria, idPatron) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/deletePatron',
			method: "POST",
			data: { idDonataria, idPatron },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then( () => {
			dispatch(isLoading(false))
			dispatch({ type: PERSIST_PATRONS_COUNCELORS, persisted: true })
			dispatch({ type: PERSIST_PATRONS_COUNCELORS, persisted: false })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}
// pendiente encriptar en mid con llave de usuario


// WEBPACK FOOTER //
// ./src/modules/Grantees/Register/PatronsCouncelors.js